module.exports = __webpack_public_path__ + "img/Camera&lens9.aef17aa4.png";